import { format } from 'date-fns';
import { getNow } from './getNow';

export const getMonthName = (month: number, locale: Locale) => {
	const date = getNow();
	date.setMonth(month);
	return format(new Date(date), 'MMMM', { locale: locale });
};
